export class ImageHelpers {
  /**
   * Compresses and resizes an image from a base64 string
   * @param {string} base64String - The base64 string representation of the image
   * @param {number} maxSize - Maximum dimension size in pixels
   * @returns {Promise<string>} A promise that resolves with the compressed image as a base64 string
   * @throws {Error} If the image processing fails or if maxSize is not provided
   */
  static async compressImage(base64String, maxSize = 1800) {
    return new Promise((resolve, reject) => {
      const img = new Image();
      img.onload = () => {
        try {
          const canvas = document.createElement("canvas");
          let width = img.width;
          let height = img.height;

          if (width > height && width > maxSize) {
            height = Math.round((height * maxSize) / width);
            width = maxSize;
          } else if (height > maxSize) {
            width = Math.round((width * maxSize) / height);
            height = maxSize;
          }

          canvas.width = width;
          canvas.height = height;

          const ctx = canvas.getContext("2d");
          ctx.imageSmoothingEnabled = true;
          ctx.imageSmoothingQuality = "high";
          ctx.drawImage(img, 0, 0, width, height);

          resolve(canvas.toDataURL("image/jpeg", 0.9));
          canvas.remove();
        } catch (error) {
          reject(new Error("Failed to process image: " + error.message));
        }
      };

      img.src = base64String;
    });
  }
}
